import ApplicationController from './application_controller'

console.log("Custom Domain Controller file loaded")

export default class extends ApplicationController {
  static targets = ["domainInput", "domainError", "validateButton", "activateButton", "saveButton", "dnsStatus"]

  connect() {
    super.connect()
    console.log("Custom Domain Contoller activated")
    if (this.hasDomainInputTarget) {
      this.validateDomain()
    }
  }

  validateDomain() {
    const domain = this.domainInputTarget.value.trim()
    const errorElement = this.domainErrorTarget
    const saveButton = this.hasSaveButtonTarget ? this.saveButtonTarget : null

    if (!domain) {
      errorElement.textContent = ""
      if (saveButton) saveButton.disabled = true
      return false
    }

    const domainParts = domain.split('.')

    if (domainParts.length > 3) {
      errorElement.textContent = "Domain must have a maximum of 3 levels (e.g., www.example.com)"
      errorElement.classList.add("text-danger")
      if (saveButton) saveButton.disabled = true
      return false
    }

    if (domainParts.length < 2) {
      errorElement.textContent = "Domain must have at least 2 levels (e.g., example.com)"
      errorElement.classList.add("text-danger")
      if (saveButton) saveButton.disabled = true
      return false
    }

    const domainRegex = /^[a-zA-Z0-9.-]+$/
    if (!domainRegex.test(domain)) {
      errorElement.textContent = "Domain contains invalid characters"
      errorElement.classList.add("text-danger")
      if (saveButton) saveButton.disabled = true
      return false
    }

    if (domain.match(/\.\./) || domain.match(/^[.-]|[.-]$/)) {
      errorElement.textContent = "Invalid domain format"
      errorElement.classList.add("text-danger")
      if (saveButton) saveButton.disabled = true
      return false
    }

    for (const part of domainParts) {
      if (part.length === 0 || part.length > 63) {
        errorElement.textContent = "Each domain part must be between 1 and 63 characters"
        errorElement.classList.add("text-danger")
        if (saveButton) saveButton.disabled = true
        return false
      }

      if (part.match(/^-|-$/)) {
        errorElement.textContent = "Domain parts cannot start or end with hyphens"
        errorElement.classList.add("text-danger")
        if (saveButton) saveButton.disabled = true
        return false
      }
    }

    errorElement.textContent = "Valid domain format"
    errorElement.classList.remove("text-danger")
    errorElement.classList.add("text-success")
    if (saveButton) saveButton.disabled = false
    return true
  }

  async checkDNS(event) {
    event.preventDefault()
    const button = event.currentTarget
    const originalText = button.textContent
    button.disabled = true
    button.textContent = "Checking DNS..."

    // Get the domain from the input field if it exists
    let domainValue = null
    if (this.hasDomainInputTarget) {
      domainValue = this.domainInputTarget.value.trim()
    }

    try {
      const body = domainValue ? { custom_domain: { domain: domainValue } } : {}

      const response = await fetch(button.dataset.checkDnsPath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify(body)
      })

      const data = await response.json()

      if (data.success) {
        let statusHtml = ''

        if (data.domain_updated) {
          statusHtml += `
            <div class="alert alert-info mb-2">
              <i class="fas fa-check-circle"></i> Domain updated to: ${data.domain}
            </div>
          `
        }

        if (data.resolving) {
          statusHtml += `
            <div class="alert alert-success">
              <strong>DNS is resolving correctly!</strong><br>
              Domain is pointing to: ${data.resolved_ip}
            </div>
          `
          if (this.hasActivateButtonTarget) {
            this.activateButtonTarget.disabled = false
          }
        } else {
          statusHtml += `
            <div class="alert alert-warning">
              <strong>DNS is not resolving correctly</strong><br>
              Expected IP: ${data.expected_ip}<br>
              Current IP: ${data.resolved_ip || 'Not resolving'}<br>
              <small>Please update your DNS records to point to the expected IP address.</small>
            </div>
          `
          if (this.hasActivateButtonTarget) {
            this.activateButtonTarget.disabled = true
          }
        }

        this.dnsStatusTarget.innerHTML = statusHtml
      } else {
        this.dnsStatusTarget.innerHTML = `
          <div class="alert alert-danger">
            <strong>Error checking DNS</strong><br>
            ${data.error || 'An unexpected error occurred'}
          </div>
        `
      }
    } catch (error) {
      this.dnsStatusTarget.innerHTML = `
        <div class="alert alert-danger">
          <strong>Error checking DNS</strong><br>
          ${error.message}
        </div>
      `
    } finally {
      button.disabled = false
      button.textContent = originalText
    }
  }

  confirmActivate(event) {
    const domain = event.currentTarget.dataset.domain
    if (!confirm(`Are you sure you want to activate the custom domain ${domain}? This will make it the primary domain for this organization.`)) {
      event.preventDefault()
    }
  }

  confirmDeactivate(event) {
    const domain = event.currentTarget.dataset.domain
    if (!confirm(`Are you sure you want to deactivate the custom domain ${domain}? The organization will revert to using the default Givsum domain.`)) {
      event.preventDefault()
    }
  }
}
